// extracted by mini-css-extract-plugin
module.exports = {"root":"FairPhones_root__1Pjo6","grid":"FairPhones_grid__28gpO","phone":"FairPhones_phone__3WSC-","headline":"FairPhones_headline__2dmGI"};